import { useCountdown } from "@/hooks/use-countdown";

interface CountdownTimerProps {
  endingDate: string;
}

export const CountdownTimerSmall = ({ endingDate }: CountdownTimerProps) => {
  const targetTimestamp = new Date(endingDate).getTime();
  const [days, hours, minutes, seconds] = useCountdown(targetTimestamp);

  return (
    <div>
      {days}d : {hours}h : {minutes}m : {seconds}s
    </div>
  );
};
